var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_434_3225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z",
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82299 11.7494C6.92739 11.93 7.07833 12.0794 7.26007 12.1818C7.44182 12.2843 7.64773 12.3362 7.85633 12.332H24.1443C24.4031 12.3371 24.6563 12.256 24.8639 12.1014C25.0717 11.9468 25.2219 11.7275 25.2913 11.4781C25.3606 11.2287 25.345 10.9633 25.247 10.7237C25.149 10.4841 24.9739 10.2839 24.7497 10.1547C24.3777 9.94136 21.4617 8.33203 16.0003 5.33203C10.539 8.33203 7.62299 9.94003 7.25099 10.1547C7.11821 10.2313 7.00183 10.3334 6.90853 10.455C6.81521 10.5767 6.74678 10.7155 6.70715 10.8636C6.66753 11.0117 6.65749 11.1662 6.67759 11.3181C6.69769 11.4701 6.74622 11.6167 6.82299 11.7494ZM19.5003 14.0827V21.6654H17.7497V14.0814H14.251V21.6654H12.499V14.0814H9.00033V21.6654H8.00033C7.6467 21.6654 7.30757 21.8059 7.05751 22.0559C6.80747 22.3059 6.66699 22.6451 6.66699 22.9987V23.9987H25.3337V22.9987C25.3337 22.6451 25.1931 22.3059 24.9431 22.0559C24.6931 21.8059 24.3539 21.6654 24.0003 21.6654H23.0003V14.0814L19.5003 14.0827Z",
    fill: "#818DA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_434_3225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeBank);
export default __webpack_public_path__ + "static/media/StripeBank.9fa87cf5f77fdb1828ef2cd666db0940.svg";
export { ForwardRef as ReactComponent };